import {CellRenderContext, IGridCellRenderer} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {TimestampCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/TimestampCell';
import {DateTimeUtil} from '@mintdata-wsp/wsp/util/DateTimeUtil';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./TimestampCell.less');
const cx = classnames.bind(styles);

export interface UpdatingTimeCellProps
{
    ctx:CellRenderContext;
}

@observer
export class UpdatingTimeCell extends React.Component<UpdatingTimeCellProps, any>
{
    render():React.ReactElement<any>
    {
        const {ctx} = this.props;
        const aCell = ctx.cell as TimestampCell;
        const timestamp = aCell.timestamp;
        const relativeFriendlyTS = DateTimeUtil.getRelativeString(timestamp);

        return  <div key={ctx.key}
                      style={ctx.style}
                      className={cx('timestampCell',
                                    ctx.className)}>

                        <div className={cx('cellContent')}>
                            {relativeFriendlyTS}
                        </div>

                </div>;
    }
}

export class TimestampRenderer implements IGridCellRenderer
{
    render(ctx:CellRenderContext):React.ReactElement<any>
    {
        return React.createElement(UpdatingTimeCell, {key:ctx.key, ctx:ctx});
    }
}
